<template>
  <div v-if="product.versions.length > 0">
    <div class="row recursive-row table-active">
      <div class="col-sm-10 ellipsis-text align-self-center">
        <button
          v-if="hasToggle"
          @click="toggleDropdown"
          class="badge badge-light badge-sm badge-toggle align-self-center"
        >
          <font-awesome-icon :icon="dropdownIcon" />
        </button>
        {{ product.name }}
      </div>
      <div
        v-if="isSuperUser || isStaffUser"
        class="col-sm-2 text-right align-self-center"
      >
        <button class="btn btn-sm" @click="selectProduct">Select</button>
      </div>
    </div>
    <version-downloads-row
      v-for="(version, index) in product.versions"
      :version="version"
      :key="version.id"
      :show="showDropdown"
      :showDownloads="index === 0"
    />
  </div>
</template>

<script>
import VersionDownloadsRow from "./VersionDownloadsRow.vue";
import ActiveTag from "../Tags/ActiveTag.vue";
import ActiveColumn from "./ActiveColumn.vue";
import config from "../../constants/config";
import { mapGetters } from "vuex";

export default {
  components: {
    VersionDownloadsRow,
    ActiveTag,
    ActiveColumn
  },
  name: "ProductVersionsRow",
  props: {
    product: Object
  },
  data() {
    return {
      showDropdown: true
    };
  },
  methods: {
    selectProduct() {
      this.$store.commit("product/selectProduct", this.product);
      this.$bvModal.show(config.PRODUCT_MODAL_ID);
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  },
  computed: {
    ...mapGetters("user", ["isSuperUser", "isStaffUser"]),
    dropdownIcon() {
      return this.showDropdown ? "angle-down" : "angle-right";
    },
    hasToggle() {
      return this.product.versions && this.product.versions.length > 0;
    }
  }
};
</script>
